"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("./app.types");
const appActionSelectMenu = payload => dispatch => {
    dispatch({ type: app_types_1.appTypes.APP_SELECT_MENU, payload });
};
const appActionCheckPath = ({ location, allMenu }) => dispatch => {
    const [, pathMenu, pathSubMenu] = location.pathname.split('/');
    const menu = allMenu.find(m => m.path.slice(1) === pathMenu);
    if (menu) {
        const subMenu = menu.subMenu.find(m => m.path.slice(1) === pathSubMenu);
        const payload = {
            menu: menu.menu,
            subMenu: subMenu ? subMenu.subMenuName : null
        };
        dispatch({ type: app_types_1.appTypes.APP_SELECT_MENU, payload });
    }
};
const appSwitchTheme = (payload) => dispatch => {
    dispatch({ type: app_types_1.appTypes.SWITCH_APP_THEME, payload });
};
const toggleSidebar = () => dispatch => {
    dispatch({ type: app_types_1.appTypes.TOGGLE_SIDEBAR, payload: undefined });
};
const manageCache = (offlineURLToCache) => __awaiter(void 0, void 0, void 0, function* () {
    if (caches) {
        const names = yield caches.keys();
        offlineURLToCache.forEach((url) => __awaiter(void 0, void 0, void 0, function* () {
            const cacheResponse = yield caches.match(url);
            if (!cacheResponse) {
                try {
                    const networkResponse = yield fetch(url);
                    names.forEach((name) => __awaiter(void 0, void 0, void 0, function* () {
                        const cache = yield caches.open(name);
                        cache.put(url, networkResponse.clone());
                    }));
                }
                catch (e) {
                    console.log(e);
                }
            }
        }));
    }
});
exports.default = {
    appActionSelectMenu,
    appActionCheckPath,
    appSwitchTheme,
    toggleSidebar,
    manageCache,
};
